export const chartColors = ["#fa6464", "#fb996d", "#2e3643", "#FFC800", "#1FD0A3", "#369AFE", "#6863FB"];